<script setup>
import CaretDownIcon from '@iconify-vue/ph/caret-down';
import ActionButton from '@js/components/buttons/ActionButton.vue';
import { Motion } from 'motion-v';
import {
    SelectContent,
    SelectItem,
    SelectItemText,
    SelectPortal,
    SelectRoot,
    SelectTrigger,
    SelectValue,
    SelectViewport,
} from 'reka-ui';
import { ref, watch } from 'vue';

const { table } = defineProps({
    table: {
        type: Object,
        required: true,
    },
});

const currentPageSize = ref(table.getState().pagination.pageSize);

const pageSizes = [10, 25, 50, 100, 250, 500];

watch(table.getState(), () => {
    currentPageSize.value = table.getState().pagination.pageSize;
});

watch(currentPageSize, () => {
    table.setPageSize(currentPageSize.value);
});
</script>

<template>
    <div class="flex items-center gap-2">
        <span class="text-sm"> Afficher </span>

        <SelectRoot v-model="currentPageSize" v-slot="{ open }">
            <SelectTrigger as-child>
                <ActionButton
                    type="secondary"
                    size="small"
                    :right-icon="CaretDownIcon"
                    :rotate-icon="open"
                >
                    <SelectValue />
                </ActionButton>
            </SelectTrigger>

            <SelectPortal>
                <SelectContent
                    position="popper"
                    :side-offset="4"
                    align="start"
                    class="z-50"
                >
                    <Motion
                        :initial="{ opacity: 0, scale: 0.96, y: -4 }"
                        :animate="{ opacity: 1, scale: 1, y: 0 }"
                        :transition="{ duration: 0.15 }"
                        class="min-w-(--reka-select-trigger-width) overflow-hidden rounded border border-gray-300 bg-white shadow-sm"
                    >
                        <SelectViewport class="max-h-60 overflow-y-auto">
                            <SelectItem
                                v-for="pageSize in pageSizes"
                                :key="pageSize"
                                :value="pageSize"
                                class="flex cursor-pointer items-center px-3 py-1 text-sm duration-150 outline-none data-[highlighted]:bg-indigo-600 data-[highlighted]:text-white data-[state=checked]:bg-indigo-600 data-[state=checked]:text-white"
                            >
                                <SelectItemText>{{ pageSize }}</SelectItemText>
                            </SelectItem>
                        </SelectViewport>
                    </Motion>
                </SelectContent>
            </SelectPortal>
        </SelectRoot>
    </div>
</template>
